import { z } from 'zod';
import { dateValidation } from '../../validation';

export const AppointmentTranscriptionSchema = z.object({
  path: z.string().min(1),
  createdAt: dateValidation(),
});

export type AppointmentTranscription = z.infer<
  typeof AppointmentTranscriptionSchema
>;
